(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["RPECK-countdown"] && !Shopify.designMode) return;
  try {
    
  
  // RPECK 03/09/2023 - onLoad
  class RPECKCounter extends HTMLElement {

    // RPECK 16/04/2024 - Which attributes to track
    static get observedAttributes() {
      return ['data-days', 'data-hours', 'data-minutes', 'data-seconds'];
    }

    // RPECK 16/04/2024 - Constructor
    constructor() {
      super();
    }

    // RPECK 16/04/2024 - ConnectedCallback
    connectedCallback() {

      // RPECK 16/04/2024 - Set up Shadow Root
      this.attachShadow({ mode: "open" });

      // RPECK 16/04/2024 - Styling
      // Allows us to add styles to the various elements of the custom element
      let styling = document.createElement('style');

      // RPECK 16/04/2024 - ShadowRoot styling
      // Required otherwise we can't access the Shadow Root
      styling.textContent = `

        :host {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 43%; left: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 100%; height: auto;
        }
      
        :host > div {
          line-height: 1;
          font-size: 4vw; 
          font-family: 'Bebas Neue', sans-serif;
          font-weight: bold;
          background-color: #ff0000;
          background-image: linear-gradient(#ff0505, #a00a0a);
          background-size: 100%;
          letter-spacing: -2px;
          -webkit-background-clip: text;
          -moz-background-clip: text;
          -webkit-text-fill-color: transparent; 
          -moz-text-fill-color: transparent;
          -webkit-filter: drop-shadow(0 0 5px rgba(255,0,0,0.6));
          filter: drop-shadow(0 0 5px rgba(255,0, 0,0.6));
        }
      
        :host > div:not(:last-of-type):after {
          content: ':';
        }

        @media screen and (max-width: 768px) {
          :host > div {
            font-size: 38px !important;
            letter-spacing: -1px;
          }
        }

        @media screen and (min-width: 2300px) {
          :host > div {
            font-size: 84px;
            letter-spacing: -1px;
          }
        }
        
      `;

      // RPECK 17/04/2024 - Append the styling to the shadow root
      this.shadowRoot.appendChild(styling);

      // RPECK 16/04/2024 - Create shadow elements from the data attributes of this
      for(var d in this.dataset) {
        
        // RPECK 16/04/2024 - Element
        var el = document.createElement('div');

        // RPECK 16/04/2024 - Set element attributes
        el.setAttribute('data-type', d);

        // RPECK 16/04/2024 - Append el to Shadow DOM
        this.shadowRoot.appendChild(el); 
        
      }

      // RPECK 03/09/2023 - Vars
      var data = window.countdown;
  
      // RPECK 03/09/2023 - Only proceed if the element is valid
      if('timestamp' in data) {   

        // Update the count down every 1 second
        var x = setInterval(function() {
        
          // Get today's date and time
          var now = new Date().getTime();
  
          // RPECK 03/09/2023 - Vars
          var countDownDate = new Date(data.year, data.month - 1, data.day, data.hour, data.minute, data.seconds);
          
          // Find the distance between now and the count down date
          var distance = countDownDate - now;
          
          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
          // Display the result in the element with id="demo"
          this.setAttribute('data-days',    ("00" + days).slice(-2));
          this.setAttribute('data-hours',   ("00" + hours).slice(-2));
          this.setAttribute('data-minutes', ("00" + minutes).slice(-2));
          this.setAttribute('data-seconds', ("00" + seconds).slice(-2));
          
          // If the count down is finished, write some text
          if (distance < 0) {
            clearInterval(x);
            this.innerHTML = "EXPIRED";
          }
          
        }.bind(this), 1000);

      }
      
    }

    // RPECK 16/04/2024 - AttributeChanged
    // Allows us to track different changed attributes
    attributeChangedCallback(name, previousValue, currentValue) {

      // RPECK 16/04/2024 - Remove the 'data-' part of the attribute name
      let id = name.split('data-')[1];

      // RPECK 16/04/2024 - Get the element with the ID cited above
      var el = this.shadowRoot.querySelector('div[data-type="' + id + '"]');

      // RPECK 16/04/2024 - If the element exists, continue
      if(el) el.innerText = currentValue;
      
    }
    
  }

  // RPECK 16/04/2024 - Add the counter to the DOM
  customElements.define("rpeck-counter", RPECKCounter);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["RPECK-featured-video"] && !Shopify.designMode) return;
  try {
    

  // Changes the state of a button depending on the data passed to it
  function changeButtonState(type, video) {
    if (type === "playpause") {
      if (video.paused || video.ended) {
        video.setAttribute("data-state", "pause");
      } else {
        video.setAttribute("data-state", "play");
      }
    } else if (type === "mute") {
      video.setAttribute("data-mute-state", video.muted ? "unmute" : "mute");
    }
  }

  // Events bound to DOM elements (IE need to wait for them to load)
  document.addEventListener("DOMContentLoaded", function() {

    // Vars
    var self_hosted_videos = document.querySelectorAll(".video-div.hosted");

    // RPECK 04/10/2023 - Only play videos if visible
    // root used to highlight entries that are not 
    // https://usefulangle.com/post/320/javascript-detect-element-visible-in-page
    const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if (!entry.isIntersecting) {
                console.log(entry);
                entry.target.pause();
                entry.target.load();
                entry.target.setAttribute("data-state", "pause");
              }
          });
    }, { root: document.documentElement });

    // Loop through videos 
    self_hosted_videos.forEach(function(video){

      // Vars
      var parent   = video.parentNode;
      var controls = parent.querySelector('.video-controls');
      var play     = controls.querySelector('button.play');
      var pause    = controls.querySelector('button.pause'); 
      var mute     = parent.querySelector('button.mute');

      // RPECK 04/10/2023 - Observer
      observer.observe(video);
      
      video.addEventListener(
        "play",
        () => {
          changeButtonState("playpause", video);
        },
        false,
      );
      
      video.addEventListener(
        "pause",
        () => {
          changeButtonState("playpause", video);
        },
        false,
      );

      if(!video.getAttribute('loop')) {
        video.addEventListener('ended', function() {
          video.load();     
        });
      }
    
      if(play) {
        play.addEventListener("click", (e) => {
          video.play();
        });
      }

      if(pause) {
        pause.addEventListener("click", (e) => {
          video.pause();
        });
      }

      if(mute) {
        mute.addEventListener("click", (e) => {
          video.muted = !video.muted;
          video.setAttribute("data-mute-state", video.muted);
        });
      }

    });
    
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    

  // RPECK 20/11/2024 - Added to give us the ability to manage the countdown block  
  function loadValues() {

    // RPECK 03/09/2023 - Elements
    document.querySelectorAll(".rpeck_date").forEach(function(element) {

      // RPECK 03/09/2023 - Only proceed if the element is valid
      if(element && 'timestamp' in element.dataset) {
  
        // RPECK 03/09/2023 - Vars
        var data            = element.dataset;
        var days_element    = element.querySelector('.days');
        var hours_element   = element.querySelector('.hours');
        var minutes_element = element.querySelector('.minutes');
        var seconds_element = element.querySelector('.seconds');
        var countDownDate   = new Date(parseInt(data.year), parseInt(data.month) - 1, parseInt(data.day), parseInt(data.hour), parseInt(data.minute), parseInt(data.seconds));
  
        // Update the count down every 1 second
        var x = setInterval(function() {
        
        // Get today's date and time
        var now = new Date().getTime();
        
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        // Display the result in the element with id="demo"
        days_element.innerText    = ("00" + days).slice(-2);
        hours_element.innerText   = ("00" + hours).slice(-2);
        minutes_element.innerText = ("00" + minutes).slice(-2);
        seconds_element.innerText = ("00" + seconds).slice(-2);
          
          // If the count down is finished, write some text
          if (distance < 0) {
            clearInterval(x);
            element.innerHTML = "EXPIRED";
          }
        }, 1000);
        
      }
            
    });
    
  }

  if (document.readyState === "loading") {
    // Loading hasn't finished yet
    document.addEventListener("DOMContentLoaded", loadValues);
  } else {
    // `DOMContentLoaded` has already fired
    loadValues();
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    

  // RPECK 03/09/2023 - onLoad
  function loadValues() {

    // RPECK 03/09/2023 - Vars
    document.querySelectorAll('.rpeck_countdown_date').forEach(function(element){
      
      // RPECK 15/11/2023 - Check if the element has the attributes
      if(element.hasAttribute('data-countdown-raw')) {

        // RPECK 03/09/2023 - Vars
        var data = {
          date:      element.getAttribute('data-countdown-raw'),
          year:      element.getAttribute('data-countdown-year'),
          month:     element.getAttribute('data-countdown-month'),
          day:       element.getAttribute('data-countdown-day'),
          hour:      element.getAttribute('data-countdown-hour'),
          minute:    element.getAttribute('data-countdown-minute'),
          seconds:   element.getAttribute('data-countdown-seconds'),
          timestamp: element.getAttribute('data-countdown-timestamp')
        }
        var days_element    = element.querySelector('.days');
        var hours_element   = element.querySelector('.hours');
        var minutes_element = element.querySelector('.minutes');
        var seconds_element = element.querySelector('.seconds');
        var countDownDate   = new Date(data.year, data.month - 1, data.day, data.hour, data.minute, data.seconds);
  
        // Update the count down every 1 second
        var x = setInterval(function() {
        
        // Get today's date and time
        var now = new Date().getTime();
        
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        // Display the result in the element with id="demo"
        days_element.innerText    = ("00" + days).slice(-2);
        hours_element.innerText   = ("00" + hours).slice(-2);
        minutes_element.innerText = ("00" + minutes).slice(-2);
        seconds_element.innerText = ("00" + seconds).slice(-2);
          
          // If the count down is finished, write some text
          if (distance < 0) {
            clearInterval(x);
            element.innerHTML = "EXPIRED";
          }
        }, 1000);
        
      }
      
    });
    
  } 

  if (document.readyState === "loading") {
    // Loading hasn't finished yet
    document.addEventListener("DOMContentLoaded", loadValues);
  } else {
    // `DOMContentLoaded` has already fired
    loadValues();
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  // RPECK 03/09/2023 - onLoad
  function loadValues() {

    // RPECK 03/09/2023 - Vars
    document.querySelectorAll('.rpeck_countdown_date').forEach(function(element){
      
      // RPECK 15/11/2023 - Check if the element has the attributes
      if(element.hasAttribute('data-countdown-raw')) {

        // RPECK 03/09/2023 - Vars
        var data = {
          date:      element.getAttribute('data-countdown-raw'),
          year:      element.getAttribute('data-countdown-year'),
          month:     element.getAttribute('data-countdown-month'),
          day:       element.getAttribute('data-countdown-day'),
          hour:      element.getAttribute('data-countdown-hour'),
          minute:    element.getAttribute('data-countdown-minute'),
          seconds:   element.getAttribute('data-countdown-seconds'),
          timestamp: element.getAttribute('data-countdown-timestamp')
        }
        var days_element    = element.querySelector('.days');
        var hours_element   = element.querySelector('.hours');
        var minutes_element = element.querySelector('.minutes');
        var seconds_element = element.querySelector('.seconds');
        var countDownDate   = new Date(data.year, data.month - 1, data.day, data.hour, data.minute, data.seconds);
  
        // Update the count down every 1 second
        var x = setInterval(function() {
        
        // Get today's date and time
        var now = new Date().getTime();
        
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        // Display the result in the element with id="demo"
        days_element.innerText    = ("00" + days).slice(-2);
        hours_element.innerText   = ("00" + hours).slice(-2);
        minutes_element.innerText = ("00" + minutes).slice(-2);
        seconds_element.innerText = ("00" + seconds).slice(-2);
          
          // If the count down is finished, write some text
          if (distance < 0) {
            clearInterval(x);
            element.innerHTML = "EXPIRED";
          }
        }, 1000);
        
      }
      
    });
    
  } 

  if (document.readyState === "loading") {
    // Loading hasn't finished yet
    document.addEventListener("DOMContentLoaded", loadValues);
  } else {
    // `DOMContentLoaded` has already fired
    loadValues();
  }
  

  } catch(e) { console.error(e); }
})();
})();
